export { DataLayerEventNameOptions, UserTypeOptions } from './constants';
export { getVisitorType } from './lib/ga-user-type';
export { useCookiebotConsent } from './lib/hooks/use-cookiebot-consent';
